import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { renderResolveMediaFunctionIdsTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/generate-resolve-media-function.js'

export function generateResolveMediaFunction(ctx: EntityCtx): string {
  const singleFields = ctx.mediaFields.map((f) => f.name)
  const arrayFields = ctx.galleryFields.map((f) => f.name)

  const collectSingle = singleFields
    .map(
      (name) =>
        `    for (const row of rows) {\n      const val = row.${name}\n      if (val && typeof val === 'string' && !val.startsWith('http')) ids.add(val)\n    }`
    )
    .join('\n')
  const collectArray = arrayFields
    .map(
      (name) =>
        `    for (const row of rows) {\n      const arr = row.${name}\n      if (Array.isArray(arr)) for (const id of arr) { if (id && !id.startsWith('http')) ids.add(id) }\n    }`
    )
    .join('\n')

  const assignSingle = singleFields
    .map(
      (name) =>
        `    row.${name}Media = row.${name} && !row.${name}.startsWith('http')\n      ? (() => {\n          const media = mediaMap.get(row.${name})\n          if (!media) return null\n          return {\n            ...media,\n            createdAtFormatted: formatActionDate(media.createdAt),\n            updatedAtFormatted: formatActionDate(media.updatedAt)\n          }\n        })()\n      : null`
    )
    .join('\n')
  const assignArray = arrayFields
    .map(
      (name) =>
        `    row.${name}Media = Array.isArray(row.${name})\n      ? row.${name}\n          .map((id: string) => {\n            const media = mediaMap.get(id)\n            if (!media) return null\n            return {\n              ...media,\n              createdAtFormatted: formatActionDate(media.createdAt),\n              updatedAtFormatted: formatActionDate(media.updatedAt)\n            }\n          })\n          .filter(Boolean) as AdminMedia[]\n      : []`
    )
    .join('\n')

  return renderResolveMediaFunctionIdsTemplate({
    ctxSingular: ctx.Singular,
    collectSingle: collectSingle,
    collectArrayContent: collectArray ? `\n${collectArray}` : '',
    map: singleFields.map((name) => `      row.${name}Media = null`).join('\n'),
    arrayFieldsContent:
      arrayFields.length > 0
        ? `\n${arrayFields.map((name) => `      row.${name}Media = []`).join('\n')}`
        : '',
    assignSingle: assignSingle,
    assignArrayContent: assignArray ? `\n${assignArray}` : ''
  })
}
